// extracted by mini-css-extract-plugin
export default {"container":"eH-z","disabled":"fH-z","bgBlack":"gH-z","content":"hH-z","countdown":"iH-z","topCaption":"jH-z","topHeading":"kH-z","heading":"lH-z","copy":"mH-z"};